import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { ScheduleMessageModal } from 'modules/ats/components/ScheduleMessageModal'

interface Props {
  label: string
  disabled?: boolean
  onSendMessage: () => void
  onSendDelayedMessage: (when: string) => void
}

export const SendMessageButton = observer(
  ({ label, disabled = false, onSendMessage, onSendDelayedMessage }: Props) => {
    const [showScheduleModal, setShowScheduleModal] = useState(false)

    const sendDelayedMessage = (when: moment.Moment) =>
      onSendDelayedMessage(dateToString(when, 'backend_datetime'))

    const handleCustomSchedule = (scheduledDate: string) => {
      onSendDelayedMessage(scheduledDate)
    }

    return (
      <>
        <Button.Split
          label={label}
          type="primary"
          aria-label={label}
          onClick={onSendMessage}
          disabled={disabled}
        >
          <Button.Split.Option onClick={onSendMessage}>
            {i18n.t('ats.candidates.messages.delayed_messages.send_now')}
          </Button.Split.Option>
          <Button.Split.Option onClick={() => sendDelayedMessage(moment().add(2, 'hours'))}>
            {i18n.t('ats.candidates.messages.delayed_messages.send_later_2_hours')}
          </Button.Split.Option>
          <Button.Split.Option onClick={() => sendDelayedMessage(moment().add(4, 'hours'))}>
            {i18n.t('ats.candidates.messages.delayed_messages.send_later_4_hours')}
          </Button.Split.Option>
          <Button.Split.Option onClick={() => sendDelayedMessage(moment().add(6, 'hours'))}>
            {i18n.t('ats.candidates.messages.delayed_messages.send_later_6_hours')}
          </Button.Split.Option>
          {moment().isBefore(moment().startOf('day').hour(18)) && (
            <Button.Split.Option
              onClick={() => sendDelayedMessage(moment().startOf('day').hour(18))}
            >
              {i18n.t('ats.candidates.messages.delayed_messages.send_today_6_pm')}
            </Button.Split.Option>
          )}
          <Button.Split.Option
            onClick={() => sendDelayedMessage(moment().add(1, 'day').startOf('day').hour(9))}
          >
            {i18n.t('ats.candidates.messages.delayed_messages.send_tomorrow')}
          </Button.Split.Option>
          <Button.Split.Option
            onClick={() => sendDelayedMessage(moment().day(8).startOf('day').hour(9))}
          >
            {i18n.t('ats.candidates.messages.delayed_messages.send_next_monday')}
          </Button.Split.Option>
          <Button.Split.Option onClick={() => setShowScheduleModal(true)}>
            {i18n.t('ats.candidates.messages.delayed_messages.schedule')}
          </Button.Split.Option>
        </Button.Split>

        <ScheduleMessageModal
          isOpen={showScheduleModal}
          onClose={() => setShowScheduleModal(false)}
          onConfirm={handleCustomSchedule}
        />
      </>
    )
  }
)
